// ========= REPLACE CONFIG BELOW =========
const COLLECTION_HANDLE = 'all'; // <- your collection handle here
// ========================================

function replaceCartProduct(line, newVariantId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: 0 })
  })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: newVariantId,
          quantity: 1
        })
      });
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product replaced:', data);
      closeEditModal();
      location.reload(); // Optionally update cart drawer instead
    })
    .catch(error => {
      console.error('Error replacing product:', error);
    });
}

window.openEditModal = function (itemData) {
  console.log('Opening modal with:', itemData);
  const modal = document.getElementById('edit-cart-modal');
  if (!modal) return;

  document.getElementById('edit-line').value = itemData.line;
  modal.style.display = 'block';

  const container = document.getElementById('replacement-product-list');
  container.innerHTML = '<p>Loading products...</p>';

  fetch(`/collections/${COLLECTION_HANDLE}/products.json`)
    .then(response => response.json())
    .then(data => {
      container.innerHTML = '';

      if (!data.products || data.products.length === 0) {
        container.innerHTML = '<p>No replacement products found.</p>';
        return;
      }

      data.products.forEach(product => {
        const variant = product.variants[0]; // First variant
        const image = product.images[0] ? product.images[0].src : '';

        const card = document.createElement('div');
        card.innerHTML = `
          <div style="border: 1px solid #e0dfdf; padding: 10px; margin-bottom: 10px; border-radius: 3px;">
            <img src="${image}" alt="${product.title}" />
            <h4 style="margin: 5px 0;">${product.title}</h4>
            <button data-variant="${variant.id}">Choose This</button>
          </div>
        `;

        card.querySelector('button').addEventListener('click', function () {
          replaceCartProduct(itemData.line, variant.id);
        });

        container.appendChild(card);
      });
    })
    .catch(error => {
      console.error('Error loading products:', error);
      container.innerHTML = '<p>Error loading products.</p>';
    });

  // Optionally hide cart drawer
  const cartDrawer = document.querySelector('.cart-drawer');
  if (cartDrawer) cartDrawer.style.display = 'none';
};

window.closeEditModal = function () {
  const modal = document.getElementById('edit-cart-modal');
  if (modal) modal.style.display = 'none';
};

// Event listener for edit buttons (works with dynamically loaded content)
document.addEventListener('click', function (e) {
  const button = e.target.closest('.edit-cart-item');
  if (button) {
    e.preventDefault();
    openEditModal({
      line: parseInt(button.dataset.line),
      variantId: button.dataset.variant,
      quantity: parseInt(button.dataset.quantity),
      customText: button.dataset.customText || '',
      engraving: button.dataset.engraving || ''
    });
  }
});
